// src/component/Account/tabs/DepositTab.jsx
import React, { useEffect, useState } from "react";
import { accountService } from "../../../services/accountService";

export default function DepositTab() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const d = await accountService.getDeposit();
      setData(d);
      setLoading(false);
    })();
  }, []);

  return (
    <section className="acc-panel">
      <h2 className="acc-title">Mon dépôt</h2>

      {loading ? (
        <div className="skel skel-line" style={{height:48}}/>
      ) : (
        <>
          <div className="acc-balance">
            Solde: <strong>{data.balance.toLocaleString(undefined, { minimumFractionDigits: 3 })} {data.currency}</strong>
          </div>
          <div className="acc-table">
            <div className="acc-tr acc-thead">
              <div>Date</div><div>Libellé</div><div>Montant</div>
            </div>
            {data.lastMovements.map(m => (
              <div className="acc-tr" key={m.id}>
                <div>{new Date(m.date).toLocaleDateString()}</div>
                <div>{m.label}</div>
                <div className={m.amount < 0 ? "neg" : "pos"}>
                  {m.amount.toLocaleString(undefined, { minimumFractionDigits: 3 })} DT
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
